import { useState } from 'react';
import type { AnimationConfig } from '@game-platform/pack-animation';
import { operatorConsole, type PoolOfferConfig } from '../../lib/api/operatorConsole';
import { PACK_OPENING_UNSUPPORTED } from './animationScope';

/** Gives one pack its own opening, or (null) hands it back to the global one. */
export function usePackOpeningWrite(packId: number) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  /** The updated pack, or null when the write failed (the reason is in `error`). */
  const write = async (animation: AnimationConfig | null): Promise<PoolOfferConfig | null> => {
    setBusy(true);
    setError(null);
    try {
      const updated = await operatorConsole.patchPoolOfferConfig(packId, { animation });
      if (animation && updated.animation == null) throw new Error(PACK_OPENING_UNSUPPORTED);
      return updated;
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Failed to save');
      return null;
    } finally {
      setBusy(false);
    }
  };

  return { busy, error, write };
}
